import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table, Switch } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, priceFenToYuanCell } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData: {
        dataList,
        pageNum,
        pageSize,
        resultTotal
    },
    tableAction,
    request,
    paginationChange
}) => {

    const switchCell = (text, { extraServiceId }) => {
        return <div style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}>
            <Switch
                checkedChildren='启用'
                unCheckedChildren='禁用'
                disabled={true}
                checked={text === 'PUT_ON_SALE' ? true : false}
                onChange={value => request(
                    '/?cmd=com.xqxc.api.pig.mis.biz.user.goods.ExtraServiceMisService.updateExtraServiceStatus',
                    { extraServiceId, status: value ? 'PUT_ON_SALE' : 'PULL_OFF_SHELVES' },
                    value ? '启用操作成功' : '禁用操作成功'
                )}
            />
        </div>;
    };

    const tableOperate = (text, item) => {
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', item)}>详情</div>
                <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>
                <div className={styles.item} onClick={() => tableAction('rate', item)}>费用比例设置</div>
            </div>
        );
    };

    const columns = [
        {
            title: '服务名称',
            dataIndex: 'serviceName',
            key: 'serviceName',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '销售价(元)',
            dataIndex: 'salePrice',
            key: 'salePrice',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: 'status',
            key: 'status',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: switchCell
        },
        {
            title: '更新时间',
            dataIndex: 'gmtModified',
            key: 'gmtModified',
            width: '20%',
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '操作',
            dataIndex: 'extraServiceId',
            key: 'extraServiceId',
            align: 'center',
            width: '20%',
            onCell: tooltipStyle,
            render: tableOperate
        },
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={item => item.extraServiceId}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={paginationChange}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    request: PropTypes.func.isRequired,//请求
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;

